import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  input,
  model,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderService } from './loader.service';
import { BlockUI } from 'primeng/blockui';

@Component({
  standalone: true,
  selector: 'app-loader',
  imports: [BlockUI],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class LoaderComponent implements OnInit {
  private service = inject(LoaderService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  content = input<any>('');
  showError = input<boolean>(false);

  showLoader = model<boolean>(false);
  loadingText = model<string>('');
  errorText = model<string>('');

  ngOnInit(): void {
    this.service.getShowLoader
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((showLoader) => {
        this.showLoader.set(showLoader);
        this.cdr.detectChanges();
      });

    if (!this.loadingText()) {
      this.service.getLoadingText
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((text) => {
          this.loadingText.set(text);
        });
    }

    if (!this.errorText()) {
      this.service.getErrorText
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((text) => {
          this.errorText.set(text);
        });
    }
  }
}
